// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: geometry_msgs/msg/PoseStamped.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Header } from "../../std_msgs/msg/Header";
import { Pose } from "./Pose";

export const protobufPackage = "geometry_msgs.msg.pb";

/** A Pose with reference coordinate frame and timestamp */
export interface PoseStamped {
  header: Header | undefined;
  pose: Pose | undefined;
}

function createBasePoseStamped(): PoseStamped {
  return { header: undefined, pose: undefined };
}

export const PoseStamped: MessageFns<PoseStamped> = {
  encode(message: PoseStamped, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(1939194666).fork()).join();
    }
    if (message.pose !== undefined) {
      Pose.encode(message.pose, writer.uint32(2178065034).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PoseStamped {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoseStamped();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 242399333: {
          if (tag !== 1939194666) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 272258129: {
          if (tag !== 2178065034) {
            break;
          }

          message.pose = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PoseStamped {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      pose: isSet(object.pose) ? Pose.fromJSON(object.pose) : undefined,
    };
  },

  toJSON(message: PoseStamped): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.pose !== undefined) {
      obj.pose = Pose.toJSON(message.pose);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PoseStamped>, I>>(base?: I): PoseStamped {
    return PoseStamped.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PoseStamped>, I>>(object: I): PoseStamped {
    const message = createBasePoseStamped();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.pose = (object.pose !== undefined && object.pose !== null) ? Pose.fromPartial(object.pose) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
